import { useState, useEffect } from 'react'
import { loadSuppliers, createSupplier, Supplier } from '../lib/apiPhpAdapter'
import './SupplierSelectorModal.css'

interface SupplierSelectorModalProps {
  onSelect: (supplierName: string) => void
  onClose: () => void
}

function SupplierSelectorModal({ onSelect, onClose }: SupplierSelectorModalProps) {
  const [suppliers, setSuppliers] = useState<Supplier[]>([])
  const [loading, setLoading] = useState(true)
  const [searchText, setSearchText] = useState('')

  // State pro přidání nového dodavatele
  const [isAdding, setIsAdding] = useState(false)
  const [newSupplierName, setNewSupplierName] = useState('')
  const [newSupplierIco, setNewSupplierIco] = useState('')
  const [creating, setCreating] = useState(false)

  useEffect(() => {
    loadSuppliersData()
  }, [])

  const loadSuppliersData = async () => {
    try {
      setLoading(true)
      const data = await loadSuppliers()
      setSuppliers(data)
    } catch (error) {
      console.error('Chyba při načítání dodavatelů:', error)
      alert('Chyba při načítání dodavatelů')
    } finally {
      setLoading(false)
    }
  }

  const handleSelect = (supplierName: string) => {
    onSelect(supplierName)
    onClose()
  }

  const handleCreateSupplier = async () => {
    if (!newSupplierName.trim()) {
      alert('Zadejte název dodavatele')
      return
    }

    try {
      setCreating(true)
      const newSupplier = await createSupplier(newSupplierName.trim(), newSupplierIco.trim() || undefined)
      // Automaticky vybrat nového dodavatele
      onSelect(newSupplier.name)
      onClose()
    } catch (error: any) {
      console.error('Chyba při vytváření dodavatele:', error)
      alert(error.message || 'Chyba při vytváření dodavatele')
    } finally {
      setCreating(false)
    }
  }

  const filteredSuppliers = suppliers.filter(supplier => {
    const searchLower = searchText.toLowerCase()
    const nameMatch = supplier.name.toLowerCase().includes(searchLower)
    const icoMatch = supplier.ico && supplier.ico.includes(searchText)
    return nameMatch || icoMatch
  })

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content supplier-selector-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Vybrat dodavatele ze seznamu</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {loading ? (
            <div className="loading">Načítání...</div>
          ) : (
            <>
              {!isAdding ? (
                <>
                  <div className="supplier-search-container">
                    <div className="supplier-search">
                      <input
                        type="text"
                        placeholder="🔍 Hledat podle názvu nebo IČO..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        className="search-input"
                      />
                    </div>
                    <button
                      className="add-supplier-button"
                      onClick={() => setIsAdding(true)}
                    >
                      + Přidat nového
                    </button>
                  </div>

                  {filteredSuppliers.length === 0 ? (
                    <div className="no-suppliers">
                      {searchText ? 'Žádní dodavatelé neodpovídají hledání' : 'Žádní dodavatelé nejsou k dispozici'}
                    </div>
                  ) : (
                    <div className="suppliers-list">
                      {filteredSuppliers.map(supplier => (
                        <div
                          key={supplier.id}
                          className="supplier-item"
                          onClick={() => handleSelect(supplier.name)}
                        >
                          <div className="supplier-info">
                            <span className="supplier-name">{supplier.name}</span>
                            {supplier.ico && <span className="supplier-ico">IČO: {supplier.ico}</span>}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <div className="add-supplier-form">
                  <h3>Přidat nového dodavatele</h3>
                  <div className="form-group">
                    <label>Název dodavatele *</label>
                    <input
                      type="text"
                      value={newSupplierName}
                      onChange={(e) => setNewSupplierName(e.target.value)}
                      placeholder="Zadejte název..."
                      autoFocus
                    />
                  </div>
                  <div className="form-group">
                    <label>IČO (volitelné)</label>
                    <input
                      type="text"
                      value={newSupplierIco}
                      onChange={(e) => setNewSupplierIco(e.target.value)}
                      placeholder="Zadejte IČO..."
                    />
                  </div>
                  <div className="form-actions">
                    <button
                      className="submit-button"
                      onClick={handleCreateSupplier}
                      disabled={creating}
                    >
                      {creating ? 'Ukládání...' : 'Uložit a vybrat'}
                    </button>
                    <button
                      className="cancel-button"
                      onClick={() => setIsAdding(false)}
                      disabled={creating}
                    >
                      Zrušit
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default SupplierSelectorModal






